import { notify } from '@billy/design-system'
import { trackError } from '@billy/track-error'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { NotificationKeys } from '../../../enums/notificationKeys'
import { UpdateCompanyOnboardingPayload } from '../query-api'
import { OnboardingForm } from '../types/onboardingForm'
import { useUpdateCompanyOnboarding } from './useUpdateCompanyOnboarding'

export const useSubmitOnboardingStepForm = (
  buildPayload: (values: OnboardingForm) => UpdateCompanyOnboardingPayload | undefined,
) => {
  const { t } = useTranslation()
  const { isProcessing: isSubmitting, update } = useUpdateCompanyOnboarding()

  const submitForm = useCallback(
    async (values: OnboardingForm) => {
      const payload = buildPayload(values)
      if (!payload) {
        return
      }

      // Persist in the background: these onboarding answers are optional and non-critical, so it's
      // not worth blocking navigation to the next step on this specific request.
      update(payload).catch((error) => {
        notify({
          id: NotificationKeys.OnboardingStepSubmitError,
          message: t('error_saving'),
          variant: 'error',
        })
        trackError(error)
      })
    },
    [buildPayload, t, update],
  )

  return { isSubmitting, submitForm }
}
